/**
 * GenericButton component.
 */
import Button from '@components/atoms/buttons/genericButton';
import Props from '@shared/types/props/pressable';
import useButton from './useButton';

/**
 * Displays the default button with the given text and action.
 * Handles the default button actions such as focus, enabled, list index, and list focused.
 */
export default function GenericButton(parentProps: Props) {
  const { callbacks, props, buttonText } = useButton({
    ...parentProps,
  });
  return (
    <Button {...props} {...callbacks} id='genericButton'>
      {buttonText}
    </Button>
  );
}
